import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InAppNotificationsService {
  private readonly eventSubject = new Subject<{ event: string; data?: any }>();

  constructor(private readonly http: HttpClient) { }

  publish(event: string, data?: any) {
    this.eventSubject.next({ event, data });
  }

  subscribe(): Observable<{ event: string; data?: any }> {
    return this.eventSubject.asObservable();
  }

  getNotificationList(params: any): Observable<any> {
    let url = environment.API_URL + `/v1/user-notifications`;
    return this.http.get(url, { params });
  }
  markAllNotificationsAsRead(): Observable<any> {
    const url = `${environment.API_URL}/v1/user-notifications`;
    return this.http.put(url, {}).pipe(
      tap(() => this.publishUnreadCountUpdate())
    );
  }

  markNotificationAsRead(notificationId: string): Observable<any> {
    const url = `${environment.API_URL}/v1/user-notifications/${notificationId}`;
    return this.http.put(url, {}).pipe(
      tap(() => this.publishUnreadCountUpdate())
    );
  }

  getNotificationCount(params?: any): Observable<any> {
    let url = environment.API_URL + `/v1/user-notifications/count`;
    return this.http.get(url, { params });
  }

  getNotificationUnReadCount(): Observable<any> {
    let url = environment.API_URL + `/v1/user-notifications/unread-count`;
    return this.http.get(url);
  }

  markNotificationAsUnread(notificationId: string): Observable<any> {
    const url = `${environment.API_URL}/v1/user-notifications/${notificationId}/un-read`;
    return this.http.put(url, {}).pipe(
      tap(() => this.publishUnreadCountUpdate())
    );
  }

  getNotificationTypes(): Observable<any> {
    let url = environment.API_URL + `/v1/user-notifications/static-types`;
    return this.http.get(url);
  }

  refreshNotificationCount() {
    this.publishUnreadCountUpdate();
  }

  private publishUnreadCountUpdate() {
    this.getNotificationUnReadCount().subscribe({
      next: (res: any) => {
        const unreadCount = res?.data?.unreadCount ?? 0;
        this.publish('NOTIFICATION_COUNT_UPDATED', unreadCount);
      },
      error: () => {
        this.publish('NOTIFICATION_COUNT_UPDATED', 0);
      }
    });
  }

}
